import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const Error = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="#FD5151" viewBox="0 0 16 16">
        <path d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zM5.65 4.815a.6.6 0 0 0-.766.07l-.07.082a.6.6 0 0 0 .07.766l2.263 2.263-2.263 2.262a.6.6 0 1 0 .849.849l2.263-2.262 2.262 2.262.083.07a.6.6 0 0 0 .766-.07l.07-.083a.6.6 0 0 0-.07-.766L8.845 7.996l2.262-2.263a.6.6 0 1 0-.849-.849L7.996 7.147 5.733 4.884z"/>
      </svg>)} {...props}/>));
export default Error;
